export * from './confirm-text.component'
